import { useDebounceCallback } from '@react-hook/debounce';
import usePmSensorAuthId from 'components/hooks/PM/usePmSensorAuthId';
import { useContext, useEffect, useState } from 'react';
import { InvestmentCarvingFiltersContext } from '../../../../../state/filters/contexts';
import usePagination from 'common/fetchHooks/usePagination';
import useTableSortBy from 'common/fetchHooks/useTableSortBy';
import { CATEGORY_ISSUES_MODEL } from '../useIssuesTable/category.issues.model';
import useResourceAllocationService from 'common/services/resource-allocation.service.versions';

export const DEFAULT_PAGINATION = {
  PAGE_SIZE: 15,
  PAGES: [15, 30, 50]
};

const useCategoryIssues = ({ selectedCategory }) => {
  const [issues, setIssues] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const {
    state: { period, filtersPayload, extraPayload }
  } = useContext(InvestmentCarvingFiltersContext);
  const raService = useResourceAllocationService();
  const pmSensorAuthId = usePmSensorAuthId();
  const pagination = usePagination(DEFAULT_PAGINATION.PAGE_SIZE);
  const tableSortBy = useTableSortBy(CATEGORY_ISSUES_MODEL.TYPE.NAME);

  const fetchIssues = useDebounceCallback(async () => {
    try {
      const res = await raService.getInvestmentCarvingCategoryIssues({
        sensor_authorization_id: pmSensorAuthId,
        category_key: selectedCategory.key,
        before: period.before,
        after: period.after,
        limit: pagination.qs.limit,
        offset: pagination.qs.offset,
        sort_by: tableSortBy.key,
        sort_dir: tableSortBy.dir,
        filtersPayload,
        extraPayload
      });
      pagination.setTotal(res?.total);
      setIssues(res.data);
    } catch (e) {
      setIssues([]);
    } finally {
      setIsLoading(false);
    }
  }, 500);

  useEffect(() => {
    if (!selectedCategory) return;
    setIsLoading(true);
    fetchIssues();
  }, [
    selectedCategory.key,
    period.before,
    period.after,
    pagination.qs.limit,
    pagination.qs.offset,
    tableSortBy.key,
    tableSortBy.dir
  ]);

  return {
    issues,
    pagination,
    tableSortBy,
    isLoading
  };
};

export default useCategoryIssues;
